// VISIT TESTERS
export const HSA_FEATURES_TOOL_TESTER_RESULTS = "dpt_dpt6064" as const;
export const HSA_FEATURES_TOOL_TESTER_DETAILS = "dpt_dpt6216_details" as const;
export const HSA_FEATURES_TOOL_TESTER_GUESTS = "dpt_dpt6216_guests" as const;
export const HSA_FEATURES_TOOL_TESTER_PAYMENT = "dpt_dpt6216_payment" as const;
export const HSA_FEATURES_TOOL_TESTER_PRIME_ACQUISITION =
  "dpt_dpt6216_prime" as const;
export const HSA_VISIT_TOOL_TESTER_RESULTS = "DPT_DPT6064" as const;

export const FLIGHTS_SUMMARY = "MAT_MAT3170" as const;

// ACME
export const HSA_PRIMEDECOUPLING = "ACME_ACME3955_PRIMEDECOUPLING_HSA" as const;
export const HSA_PRIMEDECOUPLING_MOBILE =
  "ACME_ACME4435_PRIMEDECOUPLING_HSA_MOBILE" as const;
export const HSA_PRIME_DECOUPLING_ITERATION_1 =
  "ACME_ACME4912_PRIME_DECOUPLING_ITERATION_1" as const;
export const HSA_CANCELLATION_AND_PAY_LATER_UPDATE =
  "ACME_ACME5028_CANCELLATION_AND_PAY_LATER_UPDATE_HSA" as const;
export const HSA_PAYLATER_ANON_NON_PRIME =
  "ACME_ACME5087_PAYLATER_ANON_NON_PRIME_HSA" as const;
export const HSA_LAST_CHANCE = "APES_APES3831-last-chance" as const;
export const HSA_CHECKOUT_LAYOUT_SIMPLIFIED = "TRB_TRB15434_H1_model" as const;
export const HSA_LAST_CHANCE_POPUP = "APES_APES3953-last-chance-popup" as const;
export const HSA_HOTELS_ONE_FRICTIONLESS =
  "TRB_TRB15434_H1_frictionless" as const;
export const HSA_PAY_NOW_PRESELECT_LOGGED =
  "ACME_ACME5235_PAY_NOW_PRESELECT_LOGGED" as const;
export const HSA_SB_CHECKOUT_MIGRATION =
  "ACME_ACME5258_SB_CHECKOUT_MIGRATION_HSA" as const;
export const HSA_PAYPAL_BNPL = "acme-3304-paypal-bnpl" as const;

// CRABS
export const HSA_ADS = "DPT_DPT6585_ADS" as const;
export const HSA_MAP_SPLIT_VIEW_MOBILE = "DPT_DPT7045" as const;
export const HSA_RECENTLY_USED_FILTER = "dpt_dpt3552" as const;
export const HSA_RECENTLY_USED_FILTER_BANNER = "DPT_DPT8989" as const;
export const HSA_PRIME_TRIPLE_GUARANTEE = "DPT_DPT7910" as const;
export const HSA_DIAMOND_THEME_MOBILE = "DPT-8128-M" as const;
export const HSA_DIAMOND_THEME_DESKTOP = "DPT-8128-D" as const;
export const HSA_DIAMOND_THEME_NATIVE = "DPT-8128-N" as const;
export const HSA_FILTER_WORKER = "dpt_dpt8528_filter_worker" as const;
export const HSA_DELIGHT_INTERSTITIAL_BANNER_RESULTS = "DPT_DPT8736" as const;
export const HSA_DELIGHTFUL_ROTATING_BANNER = "DPT_DPT8661" as const;
export const HSA_POPULAR_FILTERS_MOBILE = "DPT_DPT9494" as const;
export const HSA_WEB_TO_APP_DRAWER = "DPT_DPT9419" as const;
export const HSA_FLEXIBLE_MATCHING = "dpt_dpt9421" as const;

// BRAIN
export const HSA_ACCOMMODATION_CARDS_REDESIGN_DESKTOP =
  "brain_4247-cards-redesign-desktop" as const;
export const HSA_PRIME_DECOUPLING_DESKTOP =
  "brain_4435-decoupling-desktop" as const;
export const HSA_PRIME_DECOUPLING_MOBILE =
  "brain_4530-decoupling-mobile" as const;
export const HSA_CARDS_REDESIGN_ITERATION_MOBILE =
  "brain_4868-cards-redesign-iteration" as const;
export const HSA_DETAILS_ROOM_SELECTION_UP_DESKTOP =
  "brain_5036-desktop-room-selection-up" as const;

// DPF
export const HSA_ACCOMMODATION_DETAILS_OVERLAY = "DPF_DPF6052" as const;
export const HSA_MOBILE_WEB_SINGLE_TAB = "DPF_DPF7028" as const;
export const HSA_FRICTIONLESS_DETAILS_DESKTOP = "DPF_DPF7476D" as const;
export const HSA_FRICTIONLESS_DETAILS_MOBILE = "DPF_DPF7476M" as const;

// APES
export const HSA_AI_ASSISTANT_CHAT = "APES_APES3406-ai-assistant-chat" as const;
export const HSA_FRICTIONLESS_METASEARCH_GUEST_TO_PAYMENT =
  "apes_4111-frictionless-metasearch-guest-to-payment" as const;

// SE
export const HSA_SEARCH_FORM = "se_se1789-search-form-from-new-repo" as const;

// INNT
export const ACCOMMODATION_PRICE_FREEZE_SMOKE_TEST = "INNT_INNT778" as const;
export const SUPPORT_PACK_MVP_MB = "INNT_INNT510" as const;
export const SUPPORT_PACK_MVP_DK = "INNT_INNT628" as const;
export const PRICE_FREEZE_SMOKE_TEST = "INNT_INNT778" as const;
export const SUPPORT_PACK_SMOKE_TEST = "INNT_INNT591" as const;
export const HSA_PRICE_FREEZE_HOTELS_SMOKE_TEST = "INNT_INNT778" as const;

// UNCH
export const FREE_PROTECTION_INSURANCE = "UNCH_UNCH2574" as const;
